import { styled } from "@mui/material/styles";
import Checkbox from "@mui/material/Checkbox";

export const CustomCheckbox = styled(Checkbox)(() => ({
  color: "#707070",
  "&.Mui-checked": {
    color: "#1C3C6C",
  },
  "&.Mui-disabled": {
    color: "#E3E5E8",
  },
  "&.MuiCheckbox-root: hover": {
    backgroundColor: "#EDEFF3",
  },
  "&.MuiCheckbox-indeterminate": {
    color: "#1C3C6C",
  },
}));
